var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-step-button",on:{"click":function($event){return _vm.$emit('click')}}},[_c('f7-icon',{attrs:{"f7":"add","size":"18"}}),_c('label',[_vm._v("STEPを追加")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }